import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { KrogerV1RoutingModule } from './kroger.v1.routing.module';

@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    KrogerV1RoutingModule
  ]
})

export class KrogerV1Module { }
